import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { XCircle } from 'lucide-react';

export default function ErrorState({ error, onViewBookings, onGoHome }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-gray-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8">
        <XCircle className="w-16 h-16 mx-auto mb-4 text-red-500" />
        <h2 className="text-2xl font-bold text-center mb-2 text-red-600">Verification Error</h2>
        <p className="text-gray-600 text-center mb-6">{error}</p>
        <div className="flex gap-3">
          <Button onClick={onViewBookings} variant="outline" className="flex-1">
            View Bookings
          </Button>
          <Button onClick={onGoHome} className="flex-1">
            Go Home
          </Button>
        </div>
      </Card>
    </div>
  );
}
